module.exports = __webpack_public_path__ + "static/media/foto6.884bea12.JPG";